const comparisonVersion = 1;
const comparisonIntervalMs = 24 * 60 * 60 * 1000;
const comparisonRetryMs = 60 * 60 * 1000;
const rendererMetricNames = [
  'jsdomAttempts', 'jsdomRejected', 'jsdomFallbacks', 'jsdomSkippedAfterCheck',
  'rendererComparisons', 'rendererComparisonMatches', 'rendererComparisonMismatches',
  'rendererComparisonInconclusive', 'rendererComparisonErrors'
];

function rendererCheckDue(comparison, now = Date.now()) {
  return !comparison || comparison.version !== comparisonVersion ||
    !Number.isFinite(comparison.nextCheckAt) || comparison.nextCheckAt <= now;
}

function rendererBlocked(comparison, now = Date.now()) {
  return !rendererCheckDue(comparison, now) && comparison.outcome !== 'matched';
}

module.exports = {
  comparisonVersion,
  comparisonIntervalMs,
  comparisonRetryMs,
  rendererMetricNames,
  rendererCheckDue,
  rendererBlocked
};
